import { useQuery } from '@tanstack/react-query';
import type { AnnualTimetableWeekMemo } from '../../types/domain';
import {
  getAnnualTimetableWeekMemos,
  loadAnnualTimetableWeekMemosLocalCache,
} from '../../services/annualTimetableWeekMemoService';
import { schoolKeys } from '../keys';
import { lsInitialDataOptions } from './lsInitialData';

export type UseAnnualTimetableWeekMemosQueryParams = {
  workspaceId: string;
  academicYear: number;
  termNumber: 1 | 2;
  gradeIds: string[];
  enabled?: boolean;
  forceNetwork?: boolean;
};

function gradeIdsKey(gradeIds: string[]): string {
  return [...gradeIds].filter(Boolean).sort().join('\u0001');
}

export function annualTimetableWeekMemosQueryOptions(params: UseAnnualTimetableWeekMemosQueryParams) {
  const {
    workspaceId,
    academicYear,
    termNumber,
    gradeIds,
    enabled = true,
    forceNetwork = false,
  } = params;
  const ids = gradeIds.filter(Boolean);
  const gKey = gradeIdsKey(ids);
  const ls = loadAnnualTimetableWeekMemosLocalCache(workspaceId, academicYear, termNumber, ids);

  return {
    queryKey: schoolKeys.annualTimetableWeekMemos(workspaceId, academicYear, termNumber, gKey),
    enabled: enabled && !!workspaceId.trim() && ids.length > 0,
    ...lsInitialDataOptions(ls.found && !forceNetwork, ls.rows),
    queryFn: (): Promise<AnnualTimetableWeekMemo[]> =>
      getAnnualTimetableWeekMemos(workspaceId, academicYear, termNumber, ids),
  };
}

export function useAnnualTimetableWeekMemosQuery(params: UseAnnualTimetableWeekMemosQueryParams) {
  return useQuery(annualTimetableWeekMemosQueryOptions(params));
}
